<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    selectedTab:
      | 'personal-information'
      | 'investment-preferences'
      | 'disbursement-preferences'
      | 'contacts'
      | 'beneficiaries'
      | 'accreditation'
      | 'login-information'
      | 'permissions'
    isWizard?: boolean
  }>(),
  {
    isWizard: false,
  },
)

const tabs = computed(() => [
  {
    name: 'Personal Information',
    to: { name: 'investing.individual.account' },
    isActive: props.selectedTab === 'personal-information',
  },
  {
    name: 'Accreditation',
    to: { name: 'investing.individual.accreditation' },
    isActive: props.selectedTab === 'accreditation',
  },
  {
    name: 'Investment Preferences',
    to: { name: 'investing.individual.investment-preferences' },
    isActive: props.selectedTab === 'investment-preferences',
  },
  {
    name: 'Disbursement Preferences',
    to: { name: 'investing.individual.disbursement-preferences' },
    isActive: props.selectedTab === 'disbursement-preferences',
  },
  {
    name: 'Contacts',
    to: { name: 'investing.individual.contacts' },
    isActive: props.selectedTab === 'contacts',
  },
  {
    name: 'Beneficiaries',
    to: { name: 'investing.individual.beneficiaries' },
    isActive: props.selectedTab === 'beneficiaries',
  },
  {
    name: 'Login Information',
    to: { name: 'investing.individual.login-information' },
    isActive: props.selectedTab === 'login-information',
  },
  {
    name: 'Permissions',
    to: { name: 'investing.individual.permissions' },
    isActive: props.selectedTab === 'permissions',
  },
])
</script>

<template>
  <div>
    <div class="sm:flex sm:items-start sm:space-x-8 sm:px-0">
      <div class="space-y-2 sm:w-1/4">
        <RouterLink :key="tab.name" :to="tab.to" v-for="tab in tabs">
          <div class="rounded-lg p-4 text-sm" :class="{ 'bg-[#3D8A9D]/20 font-semibold text-[#3D8A9D]': tab.isActive }">
            {{ tab.name }}
          </div>
        </RouterLink>
      </div>
      <div class="sm:w-3/4">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
